import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {FeedbackItem, ProjectDepartmentModelRef} from "@views/project-plan/domain/project-plan.domain";
import AppConstants from "@utils/app.constants";
import api from "@common/services/api.service";
import {ApplicationResponse} from "@common/domain/common.model";
import {TaskModelRef} from "@views/project-tasks/domain/task.model";

export enum HODStatus  {
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    PENDING = 'PENDING',
}


const minimal = {
    value: HODStatus.PENDING,
    loading: false,
    error: '',
};
const rejectionMinimal = {
    data: [] as FeedbackItem[],
    status: "loading",
    error: "",
} ;


export const changeHodStatus = createAsyncThunk(
    'hodStatus/changeStatus',
    async (newRole: HODStatus) => {
        return newRole || HODStatus.PENDING;
    }
);

export const fetchRejectionFeedback = createAsyncThunk<any[], {
  projectId: string,
  projectType: string
}>("rejection-remarks/fetchRejectionFeedback",
    async ({projectId, projectType}) => {
        const type= projectType.toUpperCase();
      const url = `${AppConstants.api}/project/${type}/${projectId}/remarks`;
      const response = await api.get<ApplicationResponse<FeedbackItem[]>>(url);
      return response.data.data || [];
    }
)





const hodStatusSlice = createSlice({
    name: 'hodStatus',
    initialState:{
        minimal,
        rejectionMinimal 
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(changeHodStatus.pending, (state) => {
                state.minimal.loading = true;
                state.minimal.error = '';
            })
            .addCase(changeHodStatus.fulfilled, (state, action) => {
                state.minimal.loading = false;
                state.minimal.value = action.payload;
            })
            .addCase(changeHodStatus.rejected, (state, action) => {
                state.minimal.loading = false;
                state.minimal.error = action.error.message || '';
            })
             .addCase(fetchRejectionFeedback.pending, (state, action) => {
                state.rejectionMinimal = {
                   status: "loading",
                   data: [],
                   error: '',
                };
            })
             .addCase(fetchRejectionFeedback.fulfilled, (state, action) => {
                state.rejectionMinimal = {
                   status: "idle",
                   data: action.payload,
                   error: '',
                };
            })
             .addCase(fetchRejectionFeedback.rejected, (state, action) => {
                state.rejectionMinimal = {
                   status: "failed",
                   data: [],
                   error: action.error.message || '',
                };
            })
    },
});

export default hodStatusSlice.reducer;